import React, { useState, useCallback, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import moment from "moment";
import Modal from "@mui/material/Modal";
import SearchModal from "../../RosterConfigComponents/SearchModal/SearchModal";
import { useDispatch, useSelector } from "react-redux";
import SnackBar from "components/SnackBar/SnackBar";
import Chip from "@mui/material/Chip";
import CheckIcon from "@mui/icons-material/Check";
import {
  getSiteLocation,
  getClientProgram,
  getIDMUserDetails,
  getAssociatedReqIds,
  getTechDepType,
  getInfoClientDetails,
  getnewClientProgram,
} from "../../../services/userServices";
import { askNowActions } from "./../../../Store/AskNowTicket";
import { useTranslation } from "react-i18next";
import BackdropComponent from "../../../components/Spinner/Spinner";
import { generalStoreActions } from "Store/GeneralStore";
import { Autocomplete, Button } from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

const searchTrainerStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const getCurrentDateTime = () =>
  moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

const IdmInputs = (props) => {
  const rosterConfig = useSelector((state) => state.rosterConfig);
  const selectedcurrentProjectCodes = useSelector(
    (state) => state.askNow?.currentProjectCodes,
  );
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTime());
  const [miniLoading, setMiniLoading] = useState(false);
  const [taleoReqIds, setTaleoReqIds] = useState([]);
  const [siteDetails, setSiteDetails] = useState([]);
  const [orgClientProgram, setOrgClientProgram] = useState([]);
  const [clientProgram, setClientProgram] = useState([]);
  const [requestOracleId, setRequestOracleId] = useState([]);
  const [waveTrainerOracleId, setWaveTrainerOracleId] = useState([]);
  const [managerOracleId, setManagerOracleId] = useState([]);
  const [techDepType, setTechDepType] = useState([]);
  const [newClientProgram, setNewClientProgram] = useState([]);
  const { t } = useTranslation(["IdmRequest"]);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const dispatch = useDispatch();
  const askNowDetail = useSelector((state) => state.askNow);
  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };
  const [ttfDateTime, setTtfDateTime] = useState("");

  const redirectlocation = useLocation();

  useEffect(() => {
    let cancelled = false;

    const fetchDataOnLoad = async () => {
      if (!cancelled) {
        dispatch(generalStoreActions.loadingState(true));
        setCurrentDateTime(getCurrentDateTime());
      }

      try {
        const traineeDetails = askNowDetail.traineeDetailsResponse;

        const obj = {
          Email:
            redirectlocation?.state !== "assignTrainees"
              ? rosterConfig.traineeEmail
              : traineeDetails.data["rosterDetail"]["email"],
          Name:
            redirectlocation?.state !== "assignTrainees"
              ? rosterConfig.traineeName
              : traineeDetails.data["rosterDetail"]["requestFor"],
          OracleId:
            redirectlocation?.state !== "assignTrainees"
              ? rosterConfig.trainerOracle
              : traineeDetails.data["rosterDetail"]["trainerId"],
        };

        if (!cancelled) {
          setTtfDateTime(
            rosterConfig.ttfDate != ""
              ? rosterConfig.ttfDate.date
              : traineeDetails.data["rosterDetail"]["tteTrainingDate"],
          );

          dispatch(
            askNowActions.tteTrainingDate(
              rosterConfig.ttfDate != ""
                ? rosterConfig.ttfDate.date
                : traineeDetails.data["rosterDetail"]["tteTrainingDate"],
            ),
          );

          setWaveTrainerOracleId(obj);
        }

        await fetchData();

        if (cancelled) return;

        await fetchIDMuserDetails(obj.OracleId, "waveTrainer");

        if (!cancelled) {
          dispatch(generalStoreActions.loadingState(false));
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch data on load:", error);
          dispatch(generalStoreActions.loadingState(false));
        }
      }
    };

    if (askNowDetail.traineeDetailsResponse.message === "Success") {
      fetchDataOnLoad();
    }

    return () => {
      cancelled = true;
    };
  }, [askNowDetail.traineeDetailsResponse]);

  const dispatchAsknowAction = (data, type) => {
    if (type === "requestedFor") dispatch(askNowActions.requestFor(data));
    if (type === "waveTrainer") dispatch(askNowActions.waveTrainer(data));
    if (type === "manager") dispatch(askNowActions.manager(data));
  };

  const fetchIDMuserDetails = async (OracleId, type) => {
    if (OracleId) {
      const userDetails = await getIDMUserDetails(OracleId);
      if (userDetails.status === true) {
        let objuserDetails = JSON.parse(userDetails["data"]);
        if (objuserDetails.result.length > 0) {
          dispatchAsknowAction(objuserDetails.result[0].sysid, type);
        }
      } else {
        setSnack({
          open: true,
          message: "Failed to load User Details",
          severity: "error",
        });
      }
    }
  };

  const filterByProjectCodes = () => {
    const filteredCCP = orgClientProgram?.filter((item) => {
      const splitArr = item.u_client_code.split(".");
      if (splitArr.length < 4) return false;
      const projectCode = splitArr[3];
      return selectedcurrentProjectCodes?.includes(projectCode);
    });
    setClientProgram(filteredCCP);
  };
  useEffect(() => {
    setCurrentDateTime(getCurrentDateTime());
    if (selectedcurrentProjectCodes?.length > 0 && orgClientProgram?.length > 0)
      filterByProjectCodes();
  }, [selectedcurrentProjectCodes, orgClientProgram]);

  const fetchData = async () => {
    const taleoReqIds = await getAssociatedReqIds(props.rosterId);
    if (taleoReqIds.status === true) {
      setTaleoReqIds(taleoReqIds.data);
    } else {
      setSnack({
        open: true,
        message: "There are no Associated Taleo Requisition Ids'",
        severity: "info",
      });
    }

    const siteLocation = await getSiteLocation(props.classRequestId);
    if (siteLocation.status === true) {
      setSiteDetails(siteLocation.data);
    } else {
      setSnack({
        open: true,
        message: "Failed to get Site/Location details",
        severity: "error",
      });
    }

    const informaticaClientDetails = await getInfoClientDetails(
      props.classRequestId,
    );
    if (informaticaClientDetails.status !== true) {
      setSnack({
        open: true,
        message: "Failed to load Client Details",
        severity: "error",
      });
    }
    const newClientProgram = await getnewClientProgram(props.classRequestId);
    if (newClientProgram.status === true) {
      setNewClientProgram(newClientProgram.data);
    } else {
      setSnack({
        open: true,
        message: "no Associated project to get New/Client Program details",
        severity: "info",
      });
    }

    const currentClientProgram = await getClientProgram();
    if (currentClientProgram.status === true) {
      const objCurrentClientProgram = JSON.parse(currentClientProgram["data"]);
      setOrgClientProgram(objCurrentClientProgram.result);
      if (informaticaClientDetails.data.length > 0) {
        let data = objCurrentClientProgram.result.filter(
          (itm) =>
            itm.u_client_code ===
            informaticaClientDetails.data[0].u_client_code,
        );

        dispatch(askNowActions.currentClientProgram(data[0].sysid));
        dispatch(askNowActions.clientCode(data[0].u_client_code));
        dispatch(askNowActions.clientName(data[0].name));
      }
    } else {
      setSnack({
        open: true,
        message: "Failed to load  client Details",
        severity: "error",
      });
    }

    const technologyDepType = await getTechDepType();
    if (technologyDepType.status === true) {
      dispatch(
        askNowActions.techDeploymentType(technologyDepType.data[0].AskNowTDT),
      );
      setTechDepType(technologyDepType.data);
    } else {
      setSnack({
        open: true,
        message: "Failed to load Tech Deployment type Details",
        severity: "error",
      });
    }
  };

  const [requestType, setRequestType] = useState(requestTypeOptions[0]);

  const [taleoId, setTaleoId] = useState(null);
  const filter = createFilterOptions();

  const SetSiteLocation = (event, value) => {
    if (value) dispatch(askNowActions.siteLocation(value.SysId));
    else dispatch(askNowActions.siteLocation(""));
  };

  const SetNewClientProgram = (event, value) => {
    if (value) {
      dispatch(askNowActions.newClientProgram(value.SysId));
      dispatch(askNowActions.updateNewClientCode(value.ClientCode));
      dispatch(askNowActions.updateNewProgramCode(value.ProgramCode));
      dispatch(askNowActions.updateNewProjectCode(value.ProjectCode));
    } else {
      dispatch(askNowActions.newClientProgram(""));
    }
  };

  const SetTaleoReqId = (event, value) => {
    if (typeof value === "string") {
      setTaleoId({
        title: value.toUpperCase(),
      });
      dispatch(askNowActions.taleoReqId(value));
    } else if (value?.inputValue) {
      setTaleoId({
        title: value.inputValue.toUpperCase(),
      });
      dispatch(askNowActions.taleoReqId(value.inputValue));
    } else {
      setTaleoId(value);
      dispatch(askNowActions.taleoReqId(value.title));
    }
  };

  const hanldeSearchRequestedOpen = useCallback((type) => {
    setSearchType(type);
    setModalOpen(true);
  });

  const hanldeSearchRequestedClose = async (data, type) => {
    setModalOpen(false);

    if (type === "requestedFor") {
      setMiniLoading(true);
      await fetchIDMuserDetails(data.OracleId, type);
      setRequestOracleId(data);
      setMiniLoading(false);
    }

    if (type === "waveTrainer") {
      setMiniLoading(true);
      await fetchIDMuserDetails(data.OracleId, type);
      setWaveTrainerOracleId(data);
      setMiniLoading(false);
    }
    if (type === "manager") {
      setMiniLoading(true);
      setManagerOracleId(data);
      await fetchIDMuserDetails(data.OracleId, type);
      setMiniLoading(false);
    }
  };

  const [searchType, setSearchType] = useState("");
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleRequestDateChange = useCallback((event) => {
    if (event.target.value === "") {
      dispatch(askNowActions.reqForDateTime(""));
    } else {
      let currentDate = new Date(event.target.value);
      let date = moment(new Date(currentDate)).format("YYYY-MM-DD");

      let hours = currentDate.getHours();
      let minutes = currentDate.getMinutes();
      let ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours || 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      const strTime = hours + ":" + minutes + " " + ampm;
      let obj = {
        date: date,
        time: strTime,
      };
      dispatch(askNowActions.reqForDateTime(obj));
    }
  }, []);

  return (
    <Box sx={{ padding: 10 }}>
      {miniLoading ? <BackdropComponent /> : null}
      <Modal
        open={modalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={searchTrainerStyle}>
          <SearchModal
            onClose={(data, type) => hanldeSearchRequestedClose(data, type)}
            type={searchType}
          ></SearchModal>
        </Box>
      </Modal>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          {t("Wave Number")} :
        </Grid>
        <Grid
          className={"buttonContainer"}
          item
          xs={7}
          sx={{ justifyContent: "center" }}
        >
          {askNowDetail.waveNumber}
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          <span className="redColor">* </span> {t("Taleo Req ID")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ Width: "100%" }}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={taleoReqIds}
              value={taleoId}
              onChange={SetTaleoReqId}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                const isExisting = options.some(
                  (option) => inputValue === option.title,
                );
                if (inputValue !== "" && !isExisting) {
                  filtered.push({
                    inputValue,
                    title: `${t("Add")} ${inputValue}`,
                  });
                }

                return filtered;
              }}
              freeSolo
              getOptionLabel={(option) => {
                if (option.value) {
                  return option.value.title;
                }
                if (option.inputValue) {
                  return option.inputValue;
                }
                return option.title;
              }}
              renderOption={(props, option) => (
                <li {...props}>{option.title}</li>
              )}
              sx={{ maxWidth: 185 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("Taleo Req ID")}
                  sx={{ backgroundColor: "#fff", maxWidth: 190 }}
                />
              )}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          {t("Type Of Request")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ maxWidth: 300 }}>
            <select
              className="dropdown-css"
              placeholder="Type Of Request"
              onChange={(e) => {
                setRequestType(e.target.value);
                dispatch(askNowActions.typeOfRequest(e.target.value));
              }}
            >
              {requestTypeOptions.map((opt, i) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          <span className="redColor">* </span> {t("Request For")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box
            className="flex-space-between"
            sx={{ maxWidth: 300, backgroundColor: "#fff" }}
          >
            <div className="flex-space-between">{requestOracleId.Name}</div>

            <Button
              variant="contained"
              onClick={(e) => hanldeSearchRequestedOpen("requestedFor")}
              sx={{
                backgroundColor: "black",
                padding: "5px",
                color: "white",
                borderColor: "black",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#333", // Optional: darker shade on hover
                },
              }}
            >
              {t("Add")}
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          <span className="redColor">* </span> {t("Req. For Date/Time")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ maxWidth: 185, backgroundColor: "#fff" }}>
            <TextField
              id="1"
              type="datetime-local"
              className={`info-section border-radius`}
              defaultValue={currentDateTime}
              onChange={(e) => handleRequestDateChange(e)}
              sx={{ maxWidth: 185, height: 23, backgroundColor: "#fff" }}
              size="small"
              InputLabelProps={{
                shrink: true,
                classes: {
                  root: "border-yellow",
                },
              }}
            />
          </Box>
        </Grid>
      </Grid>
      {requestType === "Change Role" && (
        <Grid className={"m-2-20 padding-5-0"} container>
          <Grid className={"buttonContainer"} item xs={5}>
            <span className="redColor">* </span> {t("Req. For TimeZone")} :
          </Grid>
          <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
            <Box sx={{ maxWidth: 185 }}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={timeZones}
                defaultValue=""
                getOptionLabel={(option) => option}
                sx={{ maxWidth: 185 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Time zones"
                    sx={{ backgroundColor: "#fff" }}
                  />
                )}
                onChange={(e, option) => {
                  dispatch(askNowActions.timeZone(option));
                }}
              />
            </Box>
          </Grid>
        </Grid>
      )}

      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          {t("TCI/TTD Start Date")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ maxWidth: 185, backgroundColor: "#fff" }}>
            <TextField
              id="2"
              type="date"
              className={`info-section border-radius`}
              defaultValue=""
              value={moment(
                askNowDetail.tCITTDStartDate
                  ? new Date(askNowDetail.tCITTDStartDate)
                  : new Date("yyyy-MM-ddThh:mm"),
              ).format("YYYY-MM-DD")}
              sx={{ maxWidth: 185, height: 23, backgroundColor: "#fff" }}
              size="small"
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          <span className="redColor">* </span> {t("TTE Training Date")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ maxWidth: 185, backgroundColor: "#fff" }}>
            <TextField
              id="3"
              type="date"
              className={`info-section -radius`}
              defaultValue=""
              value={moment(
                ttfDateTime
                  ? new Date(ttfDateTime)
                  : new Date("yyyy-MM-ddThh:mm"),
              ).format("YYYY-MM-DD")}
              onChange={(e) => {
                setTtfDateTime(e.target.value);
                dispatch(askNowActions.tteTrainingDate(e.target.value));
              }}
              sx={{ maxWidth: 185, height: 23, backgroundColor: "#fff" }}
              size="small"
              InputLabelProps={{
                shrink: true,
                classes: {
                  root: "border-yellow",
                },
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          {t("Production Training Start")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ maxWidth: 185, backgroundColor: "#fff" }}>
            <TextField
              id="4"
              type="date"
              className={`info-section border-radius`}
              defaultValue=""
              inputFormat="MM/DD/YYYY"
              value={moment(
                askNowDetail.productionTrainingStart
                  ? new Date(askNowDetail.productionTrainingStart)
                  : new Date("yyyy-MM-ddThh:mm"),
              ).format("YYYY-MM-DD")}
              sx={{ maxWidth: 185, height: 23, backgroundColor: "#fff" }}
              size="small"
              InputLabelProps={{
                shrink: true,
                classes: {
                  root: "border-yellow",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          {t("Production Date")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ maxWidth: 185, backgroundColor: "#fff" }}>
            <TextField
              id="5"
              type="date"
              className={`info-section border-radius`}
              defaultValue=""
              value={moment(
                askNowDetail.productionDate
                  ? new Date(askNowDetail.productionDate)
                  : new Date("yyyy-MM-ddThh:mm"),
              ).format("YYYY-MM-DD")}
              inputFormat="MM/DD/YYYY"
              sx={{ maxWidth: 185, height: 23, backgroundColor: "#fff" }}
              size="small"
              InputLabelProps={{
                shrink: true,
                classes: {
                  root: "border-yellow",
                },
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          <span className="redColor">* </span>
          {t("Site/Location")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ width: "100%" }}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={siteDetails}
              onChange={SetSiteLocation}
              getOptionLabel={(option) => option.LocationName}
              sx={{ maxWidth: 185 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("Site/Location")}
                  sx={{ backgroundColor: "#fff", maxWidth: 190 }}
                />
              )}
            />
          </Box>
        </Grid>
      </Grid>
      {requestType === "Change Role" && (
        <Grid className={"m-2-20 padding-5-0"} container>
          <Grid className={"buttonContainer"} item xs={5}>
            <span className="redColor">* </span> {t("Current Client/Program")} :
          </Grid>
          <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
            <Box sx={{ maxWidth: 200 }}>
              <Autocomplete
                multiple
                disablePortal
                id="combo-box-demo"
                options={clientProgram}
                getOptionLabel={(option) =>
                  `${option.name} ${option.u_client_code}`
                }
                onChange={(event, value, reason) => {
                  if (value?.length) {
                    dispatch(
                      askNowActions.currentClientProgram(
                        value.map((item) => item.sysid),
                      ),
                    );
                  } else {
                    dispatch(askNowActions.currentClientProgram([{}]));
                  }

                  if (reason === "clear") {
                    dispatch(askNowActions.currentClientProgram([{}]));
                  }
                }}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("Current Client/Program")}
                    sx={{ backgroundColor: "#fff", maxWidth: 190 }}
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      title={option.name}
                      variant="filled"
                      label={option.name}
                      {...getTagProps({ index })}
                      size="medium"
                      sx={{ borderRadius: 0, color: "black" }}
                    />
                  ))
                }
                renderOption={(props, option, state) => (
                  <li {...props} key={option.sysid}>
                    {`${option.name}.${option.u_client_code}`}
                    &nbsp;
                    {state.selected && (
                      <CheckIcon fontSize="small" sx={{ color: "#ec6517" }} />
                    )}
                  </li>
                )}
              />
            </Box>
          </Grid>
        </Grid>
      )}
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          <span className="redColor">* </span> {t("New Client/Program")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ maxWidth: "100%" }}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={newClientProgram}
              onChange={SetNewClientProgram}
              getOptionLabel={(option) => option.ProjectName}
              sx={{ maxWidth: 185 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("New Client/Program")}
                  sx={{ backgroundColor: "#fff", maxWidth: 190 }}
                />
              )}
              renderOption={(props, option, state) => (
                <li {...props} key={option.sysid}>
                  {option.ProjectName}
                </li>
              )}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          <span className="redColor">* </span>
          {t("Tech. Deployment Type")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box sx={{ maxWidth: 300 }}>
            <select
              className="dropdown-css"
              placeholder={t("Tech. Deployment Type")}
              onChange={(e) => {
                dispatch(askNowActions.techDeploymentType(e.target.value));
              }}
              value={props.techEquip}
            >
              {techDepType.map((value, index) => (
                <option key={value.AskNowTDT} value={value.AskNowTDT}>
                  {value.AskNowTDT}
                </option>
              ))}
            </select>
          </Box>
        </Grid>
        <Grid></Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          {t("Equipment provisioned")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.5} sx={{ margin: "auto" }}>
          <Box sx={{ maxWidth: 300 }}>
            <div>
              <Checkbox
                type="checkbox"
                size="medium"
                sx={{
                  color: "Red",
                }}
                onChange={(e) => {
                  dispatch(askNowActions.noEquipmentRequired(e.target.checked));
                }}
              />

              <Box
                component="label"
                sx={{
                  padding: "2px",
                }}
              >
                {t("No Equipment Requirement")}
              </Box>
            </div>
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          <span className="redColor">* </span> {t("Wave Trainer")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box
            className="flex-space-between"
            sx={{ maxWidth: 300, backgroundColor: "#fff" }}
          >
            <div className="flex-space-between">
              {" "}
              {waveTrainerOracleId.Name}
            </div>

            <Button
              variant="contained"
              onClick={(e) => hanldeSearchRequestedOpen("waveTrainer")}
              sx={{
                backgroundColor: "black",
                padding: "5px",
                color: "white",
                borderColor: "black",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#333", // Optional hover effect
                },
              }}
            >
              {t("Add")}
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Grid className={"m-2-20 padding-5-0"} container>
        <Grid className={"buttonContainer"} item xs={5}>
          <span className="redColor">* </span> {t("Manager")} :
        </Grid>
        <Grid className={"m-2-20"} item xs={4.2} sx={{ margin: "auto" }}>
          <Box
            className="flex-space-between"
            sx={{ maxWidth: 300, backgroundColor: "#fff" }}
          >
            <div className="flex-space-between"> {managerOracleId.Name}</div>

            <Button
              variant="contained"
              onClick={(e) => hanldeSearchRequestedOpen("manager")}
              sx={{
                backgroundColor: "black",
                padding: "5px",
                color: "white",
                borderColor: "black",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#333", // Optional hover effect
                },
              }}
            >
              {t("Add")}
            </Button>
          </Box>
        </Grid>
      </Grid>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </Box>
  );
};

const requestTypeOptions = [
  "Activation (New Hire or Reactivation)",
  "Change Role",
];

const timeZones = [
  "(US/Mountain)",
  "Canada/Atlantic",
  "Canada/Central",
  "Africa/Accra",
  "Canada/Eastern",
  "Canada/Mountain",
  "Canada/Pacific",
  "Europe/Amsterdam",
  "Europe/Berlin",
  "Europe/Brussels",
  "Europe/Copenhagen",
  "Europe/Dublin",
  "Europe/London",
  "Europe/Madrid",
  "Europe/Paris",
  "Europe/Rome",
  "Europe/Stockholm",
  "Europe/Zurich",
  "GMT",
  "Hongkong",
  "US/Arizona",
  "US/Central",
  "US/Eastern",
  "US/Hawaii",
  "US/Mountain",
  "US/Pacific",
  "Asia/Kolkata",
  "America/Buenos_Aires",
  "America/Costa_Rica",
  "Asia/Manila",
  "Australia/Sydney",
  "Brazil/East",
  "Brazil/West",
  "Mexico/General",
  "Pacific/Auckland",
];

IdmInputs.propTypes = {
  rosterId: PropTypes.string,
  classRequestId: PropTypes.string,
  techEquip: PropTypes.string,
};

export default IdmInputs;
